import React from 'react';

/**
 * Footer Component
 * 
 * A dark-themed footer based on the specified design requirements.
 * Contains accessibility-friendly, high-contrast text against a dark background (#212529).
 * Includes project disclaimer, RERA information, and rights reserved notice.
 */
const Footer = () => {
  return (
    <footer className="footer-section bg-[#212529] text-white py-12 px-4 mt-auto">
        <div className="container mx-auto max-w-[1200px]">
          {/* Main Disclaimer Block */}
          <div className="disclaimer-content mb-8">
            <p className="text-[12px] leading-[1.8] text-center text-[#ddd] mb-6 font-sans">
              Disclaimer: The content is for information purposes only and does not constitute an offer to avail of any service. 
              Prices mentioned are subject to change without notice and properties mentioned are subject to availability. 
              Images for representation purposes only. This is the official website of authorized marketing partner. 
              We may share data with RERA registered brokers/companies for further processing. 
              We may also send updates to the mobile number/email id registered with us. All Rights Reserved.
            </p>
          </div>

          <div className="copyright-section border-t border-gray-700 pt-6 w-full text-center">
            <p className="text-[12px] text-gray-400">
              © Copyright 2026 Strategy & Marketing Partner
            </p>
          </div>
        </div>
      </footer>
  );
};

export default Footer;